import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center w-full mt-8 mb-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_3 = { class: "-mx-5 -my-2.5" }
const _hoisted_4 = { class: "flex items-center align-top" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 material-icons-outlined" }, " file_download ", -1)
const _hoisted_6 = { class: "flex items-center align-top" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 material-icons-outlined" }, " file_upload ", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "flex flex-col space-y-4"
}
const _hoisted_10 = {
  key: 3,
  class: "flex flex-col w-full mt-12 mb-12 text-center select-none"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, "topic", -1)
const _hoisted_12 = { class: "opacity-40" }
const _hoisted_13 = {
  key: 4,
  class: "flex flex-col w-full mt-12 mb-12 text-center select-none"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, " search_off ", -1)
const _hoisted_15 = { class: "opacity-40" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1 bg-gray-200 rounded-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExerciseSearchFilters = _resolveComponent("ExerciseSearchFilters")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_ExerciseEditorWrapper = _resolveComponent("ExerciseEditorWrapper")!
  const _component_ExerciseEditorWrapperSkeleton = _resolveComponent("ExerciseEditorWrapperSkeleton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ExerciseImporter = _resolveComponent("ExerciseImporter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_ExerciseSearchFilters, {
        modelValue: _ctx.searchFilter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilter) = $event)),
        onResetFilters: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchFilter = _ctx.getBlankExerciseSearchFilters()))
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.canCreateAndEditExercises)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Btn, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddExercise())),
            loading: _ctx.localLoading,
            class: "ml-auto"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("course_exercises.new_exercise")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_DropdownMenu, {
            class: "-mr-4",
            expanded: _ctx.dropdownExpanded,
            onToggleExpanded: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dropdownExpanded = !_ctx.dropdownExpanded)),
            placement: 'right'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Btn, {
                  outline: true,
                  class: "px-8 pt-2 pb-2",
                  variant: 'transparent',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onExportExercises()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("course_exercises.export_exercises")), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Btn, {
                  outline: true,
                  class: "px-8 pt-2 pb-2",
                  variant: 'transparent',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showExerciseImporter = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("course_exercises.import_exercises")), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["expanded"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_TransitionGroup, { name: "quick-bounce" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.exercises, (exercise) => {
                return (_openBlock(), _createBlock(_component_ExerciseEditorWrapper, {
                  key: 'course-' + _ctx.courseId + '-exercise-' + exercise.id,
                  exercise: exercise,
                  ref_for: true,
                  ref: 'course-' + _ctx.courseId + '-exercise-' + exercise.id,
                  id: 'course-' + _ctx.courseId + '-exercise-' + exercise.id,
                  onDelete: ($event: any) => (_ctx.onDeleteExercise(exercise)),
                  onCloneExercise: ($event: any) => (_ctx.onCloneExercise(exercise)),
                  editable: _ctx.canCreateAndEditExercises
                }, null, 8, ["exercise", "id", "onDelete", "onCloneExercise", "editable"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_ExerciseEditorWrapperSkeleton),
          _createVNode(_component_ExerciseEditorWrapperSkeleton),
          _createVNode(_component_ExerciseEditorWrapperSkeleton),
          _createVNode(_component_ExerciseEditorWrapperSkeleton)
        ])),
    (!_ctx.firstLoading && _ctx.mainStore.exercises.length === 0 && _ctx.emptyFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("course_exercises.no_exercises")), 1)
        ]))
      : (!_ctx.firstLoading && _ctx.mainStore.exercises.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t("course_exercises.no_matching_exercises")), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_VueEternalLoading, {
      load: _ctx.onLoadMore,
      "is-initial": _ctx.isInitialInfiniteLoad,
      "onUpdate:is-initial": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_Spinner)
      ]),
      "no-more": _withCtx(() => [
        _hoisted_16
      ]),
      _: 1
    }, 8, ["load", "is-initial"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showDialog,
      "confirm-only": _ctx.dialogData.confirmOnly,
      onYes: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogData.onYes?.())),
      onNo: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogData.onNo?.())),
      "yes-text": _ctx.dialogData.yesText,
      "no-text": _ctx.dialogData.noText
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.dialogData.title), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.dialogData.text), 1)
      ]),
      _: 1
    }, 8, ["showDialog", "confirm-only", "yes-text", "no-text"]),
    _createVNode(_component_Dialog, {
      "show-dialog": _ctx.showExerciseImporter,
      onNo: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showExerciseImporter = false)),
      onYes: _cache[11] || (_cache[11] = ($event: any) => (
				_ctx.importedExercises.length === 0 ? (_ctx.showExerciseImporter = false) : _ctx.onImportDone()
			)),
      dismissible: false,
      footerBorder: true,
      confirmOnly: _ctx.importedExercises.length === 0,
      noText: _ctx.$t('dialog.default_cancel_text'),
      disableOk: _ctx.importLoading,
      yesText: 
				_ctx.importedExercises.length === 0
					? _ctx.$t('dialog.default_cancel_text')
					: _ctx.importLoading
					? _ctx.$t('exercise_import.importing')
					: _ctx.$t('exercise_import.import')
			,
      fullWidth: true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("course_exercises.import_exercises_title")), 1)
      ]),
      body: _withCtx(() => [
        _createVNode(_component_ExerciseImporter, {
          onUpdateExercises: _cache[9] || (_cache[9] = ($event: any) => (_ctx.importedExercises = $event)),
          class: "mt-4 text-darkText"
        })
      ]),
      _: 1
    }, 8, ["show-dialog", "confirmOnly", "noText", "disableOk", "yesText"])
  ]))
}